import { createRef, useEffect, useRef, useState } from "react";
import { getTrans as t } from "../../../Localization/translations";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import MaterialTable from 'material-table'
import _ from "lodash";
import { toast } from "react-toastify";
import AsyncSelect from "react-select/async";
import axios from "axios";
import { API ,STRIPEPUBLICKEY,STRIPESECRETKEY} from "../../../backend";
import authHeader from "../../../services/auth-header";
import { useForm } from "react-hook-form";
import GetCompanyInfoService from "../../../services/company/getCompanyInfoService";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import PaymentExistintEle from "../CustomPayment/PaymentExistingEle";
import {
  ConnectPayments,
  ConnectComponentsProvider,
} from "@stripe/react-connect-js";
import { loadConnectAndInitialize } from "@stripe/connect-js";
import { useNavigate } from "react-router-dom";
import Helper from "../../../Helper";
import { FaAngleUp, FaAngleDown } from "react-icons/fa";

function PaymentHandleScreen() {
	const ReceipttableRef = createRef();

  const stripePromise = loadStripe(
    STRIPEPUBLICKEY
  );
  const [permissionss, setPermission] = useState(localStorage.getItem('permissions'))
	const permissionsArray = permissionss.split(',');

  const [amount, setPaymentamount] = useState(0);
  const [customer, setCustomer] = useState("");
  const [invoice, setInvoice] = useState("");
  const [stripeConnectInstance, setStripeConnectInstance] = useState(null);
  let navigate = useNavigate();
  
  const [isExpanded, setIsExpanded] = useState(false);
  const [extrafiledpayment, setExtraFiledPayment] = useState([]);
  const [additionalpayment, setAdditionalPayment] = useState([
    { attribute0: "" },
    { attribute1: "" },
    { attribute2: "" },
    { attribute3: "" },
    { attribute4: "" },
    { attribute5: "" },
    { attribute6: "" },
    { attribute7: "" },
    { attribute8: "" },
    { attribute9: "" },
    { attribute10: "" },
    { attribute11: "" },
    { attribute12: "" },
    { attribute13: "" },
    { attribute14: "" },
  ]);
  const {
    reset,
    formState: { errors: errors4 },
  } = useForm();

  const [selectedValue, setSelectedValue] = useState(null);
  const [selectedValue2, setSelectedValue2] = useState(null);
  const [inputvalue, setValue] = useState("");
  const [inputvalue2, setValue2] = useState("");
  const [paymentintentid, setPaymentIntentID] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const [stripeaccounid, setStripeAccountid] = useState("");
  const [paymentload, setPaymentLoad] = useState(false);
  const [stripedata, setStripeData] = useState([]);
  const [stripecharges_enabled, setStripeCharges_enabled] = useState();
  const [stripedetails_submitted, setStripeDetails_submitted] = useState();
  const [loadingstripe,setLoagingStripe] = useState(true)

  const getcompany = () => {
    GetCompanyInfoService.getCompanyInfo().then((response) => {
      setStripeAccountid(response.data.stripeaccount);
    })
  };
  useEffect(() => {
    getcompany();
  }, []);

  const stripereterive = () => {
    // setLoagingStripe(true)
    const response = axios
    .get(API + `paymentsub/api/retrieve-stripe/?stripeid=${stripeaccounid}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.data.success === 1) {
          setStripeData(response.data.stripe_account);
          setStripeCharges_enabled(
            response.data.stripe_account.charges_enabled
          );
          setStripeDetails_submitted(
            response.data.stripe_account.details_submitted
          );
          setLoagingStripe(false)
        }
        else{
          setLoagingStripe(false)
        }
      })
  };

  useEffect(() => {
    if (stripeaccounid !== "") {
      stripereterive();
    }
  }, [stripeaccounid]);

  useEffect(() => {
    if (stripeaccounid != "") {
      const fetchClientSecretaccount = async () => {
        try {
          const response = await fetch(
            API +
              `paymentsub/api/account_session/?account_id=${stripeaccounid}`,
            { method: "POST" }
          );

          if (!response.ok) {
            const { error } = await response.json();
            return undefined;
          } else {
            const { client_secret: clientSecret } = await response.json();
            return clientSecret;
          }
        } catch (error) {
          console.error(
            "An error occurred while fetching client secret: ",
            error
          );
          return undefined;
        }
      };

      const initializeStripeConnect = async () => {
        try {
          const secret = await fetchClientSecretaccount();

          if (secret) {
            const instance = loadConnectAndInitialize({
              // publishableKey:
              //   "pk_test_51NtSnlLKpVRgqWxom6iTaBorBjLi2pN6xJZIsOOwHcnwrEPGUZZdX0DlPrtyvsCrXyfAWkjvo4ApMNles7mwWvrD00lXbFgo1d",
              publishableKey:
               STRIPEPUBLICKEY,
              fetchClientSecret: fetchClientSecretaccount,
              appearance: {
                overlays: "dialog",
                variables: {
                  colorPrimary: "#625afa",
                },
              },
              // fonts: [
              //   {
              //     cssSrc: "https://myfonts.example.com/mycssfile.css",
              //   },

              // ]
            });

            setStripeConnectInstance(instance);
          }
        } catch (error) {
          console.error(
            "An error occurred while initializing Stripe Connect: ",
            error
          );
        }
      };

      initializeStripeConnect();
    }
  }, [stripeaccounid]);

  useEffect(() => {
    if (clientSecret !== "" || stripeaccounid !== "") {
      fetchClientSecret();
    }
  }, [stripeaccounid]);

  const fetchCalled = useRef(false);
  const fetchClientSecret = async () => {
    if (paymentload === false) {
      if (!fetchCalled.current) {
        fetchCalled.current = true;
        try {
          const amounts = 10;
          if (amounts !== null) {
            const response = await fetch(
              API + "accounting/create-payment-stripeaccount/",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  items: ["item1", "item2"],
                  amount: amounts,
                  plan: "Annual",
                  accountid: stripeaccounid,
                }),
              }
            );

            if (!response.ok) {
              throw new Error("Network response was not ok");
            }

            const data = await response.json();
            setPaymentLoad(true);
            setClientSecret(data.clientSecret);
            setPaymentIntentID(data.intent_id.id);
          }
        } catch (error) {
          console.error("Error fetching client secret:", error);
        }
      }
    }
  };
  const handelInputChange = (value) => {
    setValue(value);
  };

  const handelInputChange2 = (value) => {
    setValue2(value);
  };

  const loadOptions = async (inputValue) => {
    if (inputValue !== "") {
      const responseJSON = await axios.get(
        API +
          `parties/vendor/?party_type=Customer&&customer_name=${inputValue}`,
        { headers: authHeader() }
      );
      return responseJSON.data.data;
    }
  };

  const customePermission = localStorage.getItem("customer");

  useEffect(() => {
    const customerget = async () => {
      const response = await axios.get(
        API + `parties/customerparty/?party_type=Customer&&customer_name=`,
        { headers: authHeader() }
      );
      if (response.data.length > 0) {
        setSelectedValue(response.data[0].party);
        setCustomer(response.data[0].party);
      }
    };
    if (customePermission === "Customer") {
      customerget();
    }
  }, []);

  const loadOptions2 = async (inputValue2) => {
    if (inputValue2 !== "") {
      const responseJSON = await axios.get(
        API +
          `billing/invoicefilter/?invoice_number=${inputValue2}&customerid=${
            selectedValue ? selectedValue.id : selectedValue
          }`,
        { headers: authHeader() }
      );
      return responseJSON.data.data;
    }
  };

  const paymentamount = async () => {
    const responseJSON = await axios.get(
      API +
        `billing/invoicepaymentamount/?invoicenumber=${
          invoice ? invoice.invoice_number : ""
        }&customerid=${customer ? customer.id : ""}`,
      { headers: authHeader() }
    );
    setPaymentamount(responseJSON.data.total_amount);
    return responseJSON.data;
    // }
  };
  useEffect(() => {
    if (invoice !== "") {
      paymentamount();
    }
    if (customer !== "") {
      paymentamount();
    }
  }, [invoice, customer]);
  const handelChange = (value) => {
    if (value == null) {
      setCustomer("");
      setSelectedValue("");
      reset({
        selectedValue: "",
      });
      setPaymentamount("");
    } else {
      setSelectedValue(value);
      reset({
        selectedValue: value.id,
      });

      setCustomer(value);
    }
  };

  const handelChange2 = (value) => {
    if (value !== null) {
      setSelectedValue2(value);
      reset({
        selectedValue2: value.id,
      });
      // }
      setInvoice(value);
    } else {
      setSelectedValue2("");
      reset({
        selectedValue2: "",
      });
      setInvoice("");
      setPaymentamount("");
    }
  };

  const getExtrafiled = () => {
    GetCompanyInfoService.getExtraFiled().then((response) => {
      setExtraFiledPayment(response.data.existpayment);
    })
  };

  // const handleclick = () => {
  //   navigate("/paymentstripe")
  // };

  useEffect(() => {
    let response = [];
    getExtrafiled();
 
  }, []);

   const toggleFields = () => {
    setIsExpanded(!isExpanded);
  };

  const onChangeextrafileds = (e, index) => {
    const { name, value } = e.target;
    const rowsInput = [...additionalpayment];
    rowsInput[index][name] = value;
    setAdditionalPayment(rowsInput);
  };


  return (
    <>
      <div className="container-fluid">
        <h2 className="text-center mb-5 tc pt-4">Payment</h2>
        <div className="payment-content pa-co" style={{ paddingLeft: "10px" }}>
          <div className="">
            <div className="">
            {stripecharges_enabled === true ? (
              <div className="row">
                <div className="col-xl-6 card card-body  ">
                  <div className="row mt-2 mb-2 ">
                    <div className="col-xl-6 ">
                      <label className="col-lg-12 col-form-label required">
                        {t("Customer")}{" "}
                        <Tooltip content={t("Customer_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      {customePermission === "Customer" ? (
                        <div className="col-lg-12">
                          <AsyncSelect
                            defaultOptions
                            isClearable
                            placeholder={t("Search for Customer(%for All)")}
                            value={selectedValue}
                            // options={selectedValue}
                            isDisabled
                            getOptionLabel={(e) => e.customer_name}
                            getOptionValue={(e) => e.customer_name}
                            loadOptions={loadOptions}
                            onInputChange={handelInputChange}
                            onChange={handelChange}
                            name="selectedValue"
                          ></AsyncSelect>
                        </div>
                      ) : (
                        <div className="col-lg-12">
                          <AsyncSelect
                            defaultOptions
                            isClearable
                            placeholder={t("Search for Customer(%for All)")}
                            value={selectedValue}
                            getOptionLabel={(e) => e.customer_name}
                            getOptionValue={(e) => e.customer_name}
                            loadOptions={loadOptions}
                            onInputChange={handelInputChange}
                            onChange={handelChange}
                            name="selectedValue"
                          ></AsyncSelect>
                        </div>
                      )}
                    </div>
                    <div className="col-xl-6">
                      <label className="col-lg-12 col-form-label required">
                        {t("Invoice")}{" "}
                        <Tooltip content={t("Customer_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <div className="col-lg-12">
                        <AsyncSelect
                          defaultOptions
                          isClearable
                          placeholder={t("Type Invoice Number")}
                          value={selectedValue2}
                          getOptionLabel={(e) => e.invoice_number}
                          getOptionValue={(e) => e.id}
                          loadOptions={loadOptions2}
                          onInputChange={handelInputChange2}
                          onChange={handelChange2}
                          name="selectedValue2"
                        ></AsyncSelect>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-6">
                    <div className="form-group row">
                      <label className="col-lg-12 col-form-label required">
                        {t("Amount ")}{" "}
                        <Tooltip content={t("Contract_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <div className="col-lg-12">
                        <input
                          value={amount}
                          type="number"
                          min='0'
                          className="form-control no-spinner"
                          name="amount"
                          id="contract_number"
                          onChange={(e) => setPaymentamount(e.target.value)}
                        />
                      </div>
                    </div>
                    </div>
                      <div className="mb-6 col-md-12" >
                      <h5
                          className="tc mt-4 cursor-pointer"
                          onClick={toggleFields}
                        >
                          {t("Additional Information")}{" "}
                          {isExpanded === true ? (
                            <FaAngleUp />
                          ) : (
                            <FaAngleDown />
                          )}
                        </h5>
                      
                      {isExpanded === true && (
                        <div className="form-group row">
                          {extrafiledpayment.map((key, index) => (
                            <div
                              className={
                                key.enable === "True" ? "col-sm-6" : null
                              }
                            >
                              <>
                                <label
                                  style={{
                                    display:
                                      key.enable === "True" ? true : "none",
                                  }}
                                  className="col-form-label"
                                >
                                  {" "}
                                  {key.label}{" "}
                                  <Tooltip content={key.label}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </label>
                                <input
                                  style={{
                                    display:
                                      key.enable === "True" ? true : "none",
                                  }}
                                  className="form-control mb-1"
                                  name={"attribute" + index}
                                  type={key.datatype}
                                  placeholder={key.label}
                                  onChange={(e) =>
                                    onChangeextrafileds(e, index)
                                  }
                                />
                              </>
                            </div>
                          ))}
                        </div>
                      )}
                      <input
                        type="hidden"
                        value="Entered"
                        className="form-control"
                        name="status"
                        id="status"
                        disabled
                      />
                      <input
                        type="hidden"
                        className="form-control"
                        name="sign_date"
                        id="signdate"
                      />
                      <textarea
                        style={{ display: "none" }}
                        className="form-control"
                        id="description"
                        name="description"
                      ></textarea>
                      <input
                        type="hidden"
                        style={{ display: "none" }}
                        value="USD"
                        className="form-control"
                        name="currency"
                        id="currency"
                      />  

                        </div>

                    <div className="col-md-6">

                    {clientSecret && (
                      <Elements
                        stripe={stripePromise}
                        options={{ clientSecret }}
                      >
                        <PaymentExistintEle
                          amount={amount}
                          paymentintentid={paymentintentid}
                          clientSecret={clientSecret}
                          inoviceid={selectedValue2 ? selectedValue2.id : ""}
                          customer_id={selectedValue ? selectedValue.id : ""}
                        />
                      </Elements>
                    )}
                  </div>
                  </div>
                
                <div className=" col-xl-6">
                  {customePermission !== "Customer" ? (
                    <div className=" card">
                      <div className="col-xl-12">
                        {stripecharges_enabled === true ? (
                          <div className="container-fluid mt-2 mb-2">
                            <div className="container-fluid mt-2 mb-2">
                            <MaterialTable
														tableRef={ReceipttableRef}
														style={{
															backgroundColor: "var(--bs-table-bg)",
															borderBottomWidth: "1px",
															boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
														}}
														title={<h5 className="mb-0" >{t("Receipts")}</h5>}
														columns={[
															{
																title: `${t("Receipt No")}`,
																field: "receipt_number",
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																},
															},


															{
																title: `${t("Contract Number")}`,
																field: "contract_id.contract_number",
                                render: rowData => <> <div className="d-xl-none tc d-md-none d-lg-none">{t("Contract Number")}</div> <div>{(rowData.contract_id ? rowData.contract_id.contract_number : "None")}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
															{
																title: `${t("Customer Name")}`,
																field: "customer_id.customer_name",
																render: rowData => <> <div className="d-xl-none tc d-md-none d-lg-none">{t("Customer Name")}</div> <div>{rowData.customer_id ? rowData.customer_id.customer_name : "None"}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
															{
																title: `${t("Receipt Amount")}`,
																field: "receipt_amount",
																render: rowData => <> <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
																>{t("Receipt Amount")}</div>
																	<div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}> {Helper.Amount(rowData.receipt_amount)}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "right"
																},
																// cellStyle: {
																// 	textAlign: "right",
																// 	fontSize: 12
																// }
															},

															{
																title: `${t("Applied Amount")}`,
																field: "applied_amount",
																render: rowData => <> <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
																>{t("Applied Amount")}</div>
																	<div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.applied_amount)}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "right"
																},
																// cellStyle: {
																// 	textAlign: "right",
																// 	fontSize: 12
																// }
															},
															{
																title: `${t("Receipt Method")}`,
																field: "receipt_method",
																render: rowData => <> <div className="d-xl-none tc d-md-none d-lg-none">{t("Receipt Method")}</div> <div>{rowData.receipt_method}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
															{
																title: `${t("Receipt Date")}`,
																field: "receipt_date",
																render: rowData => <> <div className="d-xl-none tc d-md-none d-lg-none">{t("Receipt Date")}</div> <div>{Helper.DateNormal(rowData.receipt_date)}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
															{
																title: `${t("Receipt Status")}`,
																field: "status",
																render: rowData => <> <div className="d-xl-none tc d-md-none d-lg-none">{t("Receipt Status")}</div> <div>{rowData.status}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},		
														]}
														// data={items}
														data={query =>
															new Promise((resolve, reject) => {
																const { orderBy, orderDirection } = query;

																let url = API + "receipts/view/receipts/?"
																url += `status=`
																url += '&per_page=' + query.pageSize
																url += '&page=' + (query.page + 1)
																url += '&search=' + query.search
																url += '&contractNumber='
																url += '&customerName='
																if (orderBy) {
																	url += `&orderBy=${orderBy.field}`;
																	url += `&orderDirection=${orderDirection}`;
																}
																fetch(url, { headers: authHeader() })
																	.then(response => response.json())
																	.then(result => {
																		resolve({
																			data: query.orderBy && query.orderDirection
																				? _.orderBy(
																					result.data,
																					[query.orderBy.field],
																					[query.orderDirection]
																				)
																				: result.data,
																			page: result.page - 1,
																			totalCount: result.total,
																		})
																	})
															})
														}
														options={{
															headerStyle: {
																backgroundColor: "white",
																color: "#245C7F",
																fontSize: 10,
															},
															rowStyle: (rowData, index) => {
																if (index % 2) {
																	return { backgroundColor: "#fff" }
																}
															},
															sorting: true,
															search: false,
															toolbar: true,
															paging: true,
															pageSize: 10,       // make initial page size
															emptyRowsWhenPaging: false,   // To avoid of having empty rows
															pageSizeOptions: [10, 25, 30, 50],
															paginationType: "stepped",
															showFirstLastPageButtons: false,
															actionsColumnIndex: -1,
														}}
													/>
                          </div>
                            {/* <ConnectComponentsProvider
                              connectInstance={stripeConnectInstance}
                            >
                              <ConnectPayments />
                            </ConnectComponentsProvider> */}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className=" card">
                      <div className="col-xl-12">
                        {stripecharges_enabled === true ? (
                          <div className="container-fluid mt-2 mb-2">
                            <MaterialTable
														tableRef={ReceipttableRef}
														style={{
															backgroundColor: "var(--bs-table-bg)",
															borderBottomWidth: "1px",
															boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
														}}
														title={<h5 className="mb-0" >{t("Receipts")}</h5>}
														columns={[
															{
																title: `${t("Receipt No")}`,
																field: "receipt_number",
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																},
															},


															{
																title: `${t("Contract Number")}`,
																field: "contract_id.contract_number",
                                render: rowData => <> <div className="d-xl-none tc d-md-none d-lg-none">{t("Contract Number")}</div> <div>{(rowData.contract_id ? rowData.contract_id.contract_number : "None")}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
															{
																title: `${t("Customer Name")}`,
																field: "customer_id.customer_name",
																render: rowData => <> <div className="d-xl-none tc d-md-none d-lg-none">{t("Customer Name")}</div> <div>{rowData.customer_id ? rowData.customer_id.customer_name : "None"}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
															{
																title: `${t("Receipt Amount")}`,
																field: "receipt_amount",
																render: rowData => <> <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
																>{t("Receipt Amount")}</div>
																	<div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}> {Helper.Amount(rowData.receipt_amount)}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "right"
																},
																// cellStyle: {
																// 	textAlign: "right",
																// 	fontSize: 12
																// }
															},

															{
																title: `${t("Applied Amount")}`,
																field: "applied_amount",
																render: rowData => <> <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
																>{t("Applied Amount")}</div>
																	<div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.applied_amount)}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "right"
																},
																// cellStyle: {
																// 	textAlign: "right",
																// 	fontSize: 12
																// }
															},
															{
																title: `${t("Receipt Method")}`,
																field: "receipt_method",
																render: rowData => <> <div className="d-xl-none tc d-md-none d-lg-none">{t("Receipt Method")}</div> <div>{rowData.receipt_method}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
															{
																title: `${t("Receipt Date")}`,
																field: "receipt_date",
																render: rowData => <> <div className="d-xl-none tc d-md-none d-lg-none">{t("Receipt Date")}</div> <div>{Helper.DateNormal(rowData.receipt_date)}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
															{
																title: `${t("Receipt Status")}`,
																field: "status",
																render: rowData => <> <div className="d-xl-none tc d-md-none d-lg-none">{t("Receipt Status")}</div> <div>{rowData.status}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},		
														]}
														// data={items}
														data={query =>
															new Promise((resolve, reject) => {
																const { orderBy, orderDirection } = query;

																let url = API + "receipts/view/receipts/?"
																url += `status=`
																url += '&per_page=' + query.pageSize
																url += '&page=' + (query.page + 1)
																url += '&search=' + query.search
																url += '&contractNumber='
																url += '&customerName='
																if (orderBy) {
																	url += `&orderBy=${orderBy.field}`;
																	url += `&orderDirection=${orderDirection}`;
																}
																fetch(url, { headers: authHeader() })
																	.then(response => response.json())
																	.then(result => {
																		resolve({
																			data: query.orderBy && query.orderDirection
																				? _.orderBy(
																					result.data,
																					[query.orderBy.field],
																					[query.orderDirection]
																				)
																				: result.data,
																			page: result.page - 1,
																			totalCount: result.total,
																		})
																	})
															})
														}
														options={{
															headerStyle: {
																backgroundColor: "white",
																color: "#245C7F",
																fontSize: 10,
															},
															rowStyle: (rowData, index) => {
																if (index % 2) {
																	return { backgroundColor: "#fff" }
																}
															},
															sorting: true,
															search: false,
															toolbar: true,
															paging: true,
															pageSize: 10,       // make initial page size
															emptyRowsWhenPaging: false,   // To avoid of having empty rows
															pageSizeOptions: [10, 25, 30, 50],
															paginationType: "stepped",
															showFirstLastPageButtons: false,
															actionsColumnIndex: -1,
														}}
													/>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )
            :
            loadingstripe === false ? 
            <div className="mt-10 text-center justify-content-center">
              <h3>Please sign up for Stripe to process payments</h3>
              </div>
            :""
                  }
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PaymentHandleScreen;
